<template>
  <div
    class="HospitalsDetailAbstract"
    :class="{ isList: isList, isNarrow: isNarrow }"
  >
    <ul
      class="hospitalsDetailData"
      v-if="
        detail.bed_num ||
          detail.doctor_num ||
          detail.outpatient_num_avg ||
          detail.inpatient_num_avg ||
          detail.emergency_num_avg ||
          detail.ambulance_num
      "
    >
      <li class="hospitalsDetailData_item" v-if="!isList && detail.bed_num">
        <p class="hospitalsDetailData_title">病床数</p>
        <div class="hospitalsDetailData_inner">
          <div class="hospitalsDetailData_unit">
            <div class="hospitalsDetailData_icon">
              <img src="@/assets/images/icon/bed.svg" alt="" />
            </div>
            <div class="hospitalsDetailData_cnt">
              <p class="hospitalsDetailData_num">
                <span>
                  {{ numberFormatAddComma(detail.bed_num) }}
                </span>
                床
              </p>
            </div>
          </div>
        </div>
      </li>
      <li class="hospitalsDetailData_item" v-if="!isList && detail.doctor_num">
        <p class="hospitalsDetailData_title">医師数</p>
        <div class="hospitalsDetailData_inner">
          <div class="hospitalsDetailData_unit">
            <div class="hospitalsDetailData_icon">
              <img src="@/assets/images/icon/doctor.svg" alt="" />
            </div>
            <div class="hospitalsDetailData_cnt">
              <p class="hospitalsDetailData_label"></p>
              <p class="hospitalsDetailData_num">
                <span>
                  {{ numberFormatAddComma(detail.doctor_num) }}
                </span>
                人
              </p>
            </div>
          </div>
        </div>
      </li>
      <li
        class="hospitalsDetailData_item"
        :class="{
          'hospitalsDetailData_item--l':
            detail.outpatient_num_avg && detail.inpatient_num_avg
        }"
        v-if="detail.outpatient_num_avg || detail.inpatient_num_avg"
      >
        <p class="hospitalsDetailData_title">患者データ</p>
        <div class="hospitalsDetailData_inner">
          <div
            class="hospitalsDetailData_unit"
            v-if="detail.outpatient_num_avg"
          >
            <div class="hospitalsDetailData_icon">
              <img src="@/assets/images/icon/user-patient.svg" alt="" />
            </div>
            <div class="hospitalsDetailData_cnt">
              <p class="hospitalsDetailData_label">外来患者数</p>
              <p class="hospitalsDetailData_num">
                <span>
                  {{ numberFormatAddComma(detail.outpatient_num_avg) }}
                </span>
                名/日
              </p>
            </div>
          </div>

          <div class="hospitalsDetailData_unit" v-if="detail.inpatient_num_avg">
            <div class="hospitalsDetailData_icon">
              <img src="@/assets/images/icon/bed.svg" alt="" />
            </div>
            <div class="hospitalsDetailData_cnt">
              <p class="hospitalsDetailData_label">
                入院患者数
              </p>
              <p class="hospitalsDetailData_num">
                <span>
                  {{ numberFormatAddComma(detail.inpatient_num_avg) }}
                </span>
                名/日
              </p>
            </div>
          </div>
        </div>
      </li>

      <li
        class="hospitalsDetailData_item"
        :class="{
          'hospitalsDetailData_item--l':
            detail.emergency_num_avg && detail.ambulance_num
        }"
        v-if="detail.emergency_num_avg || detail.ambulance_num"
      >
        <p class="hospitalsDetailData_title">
          年間件数<span
            v-if="detail.out_of_hours || detail.ambulance_out_of_hours"
            >（※うち時間外件数）</span
          >
        </p>
        <div class="hospitalsDetailData_inner">
          <div class="hospitalsDetailData_unit" v-if="detail.emergency_num_avg">
            <div class="hospitalsDetailData_icon">
              <img src="@/assets/images/icon/user.svg" alt="" />
            </div>
            <div class="hospitalsDetailData_cnt">
              <p class="hospitalsDetailData_label">
                救急外来患者
              </p>
              <p class="hospitalsDetailData_num">
                <span>
                  {{ numberFormatAddComma(detail.emergency_num_avg) }}
                </span>
                件
                <span
                  v-if="detail.out_of_hours"
                  class="hospitalsDetailData_sub"
                >
                  ({{
                    numberFormatAddComma(detail.out_of_hours)
                  }}件<span>※</span>)
                </span>
              </p>
            </div>
          </div>

          <div class="hospitalsDetailData_unit" v-if="detail.ambulance_num">
            <div class="hospitalsDetailData_icon">
              <img src="@/assets/images/icon/car.svg" alt="" />
            </div>
            <div class="hospitalsDetailData_cnt">
              <p class="hospitalsDetailData_label">
                救急車搬送
              </p>
              <p class="hospitalsDetailData_num">
                <span>
                  {{ numberFormatAddComma(detail.ambulance_num) }}
                </span>
                件
                <span
                  v-if="detail.ambulance_out_of_hours"
                  class="hospitalsDetailData_sub"
                >
                  ({{
                    numberFormatAddComma(detail.ambulance_out_of_hours)
                  }}件<span>※</span>)
                </span>
              </p>
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

import { numberFormatAddComma } from '@/utils/commonMethods'

export default defineComponent({
  name: 'HospitalsDetailAbstract',
  props: {
    detail: {
      type: Object,
      default: () => ({})
    },
    isList: {
      type: Boolean,
      dfault: false
    },
    isNarrow: {
      type: Boolean,
      dfault: false
    }
  },

  setup() {
    return {
      numberFormatAddComma
    }
  }
})
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;
.HospitalsDetailAbstract {
  padding: 12px 16px 40px;
  @include mixins.media() {
    max-width: 1128px;
    margin-right: auto;
    margin-left: auto;
    padding: 32px 20px 56px;
  }
  &.isList {
    padding: 16px 0 0;
    .hospitalsDetailData_item {
      width: 100%;
    }
    @include mixins.media('lg') {
      .hospitalsDetailData {
        flex-wrap: nowrap;
      }
      .hospitalsDetailData_title {
        font-size: 1.2rem;
      }
      .hospitalsDetailData_item {
        width: auto;
        flex: 1 1 auto;
        &:first-child {
          flex: 0 1 284px;
          width: 284px;
        }
      }
      .hospitalsDetailData_inner {
        padding: 12px 36px;
        gap: 0 40px;
      }
      .hospitalsDetailData_unit {
        flex-direction: column;
      }
      .hospitalsDetailData_icon {
        margin: 0 auto 8px;
      }
      .hospitalsDetailData_label {
        font-size: 1.2rem;
        font-weight: normal;
        text-align: center;
      }
      .hospitalsDetailData_num {
        font-size: 1.2rem;
        > span {
          font-size: 1.6rem;
        }
      }
      .hospitalsDetailData_sub {
        font-size: 1.2rem !important;
      }
    }
  }
  &.isNarrow {
    @include mixins.media('lg') {
      .hospitalsDetailData {
        flex-wrap: wrap;
      }
      .hospitalsDetailData_item {
        width: 100% !important;
        flex: 1 1 100% !important;
      }
    }
  }
}
.hospitalsDetailData {
  display: flex;
  flex-wrap: wrap;

  @include mixins.media('lg') {
    align-items: stretch;
  }

  &_item {
    width: 50%;
    &:nth-child(even) {
      border-left: 1px solid #fff;
    }
    &:nth-child(n + 3) {
      width: 100%;
      border-left: none !important;
    }
    @include mixins.media('lg') {
      width: 148px;
      flex: 0 0 auto;
      display: flex;
      flex-direction: column;

      &:nth-child(n) {
        border-left: 1px solid #fff;
      }
      &:nth-child(3) {
        width: 336px;
        border-left: 1px solid #fff !important;
      }
      &:nth-child(4) {
        width: calc(100% - 632px);
        border-left: 1px solid #fff !important;
      }
    }
  }
  &_title {
    text-align: center;
    background-color: #e4e4e4;
    font-size: 1.1rem;
    font-weight: bold;
    line-height: 2.2;
    word-break: keep-all;
    white-space: nowrap;
    span {
      font-weight: normal;
    }
    @include mixins.media('lg') {
      font-size: 1.4rem;
      span {
        font-size: 1.1rem;
      }
    }
  }
  &_inner {
    width: 100%;
    display: flex;
    align-items: stretch;
    background-color: #f5f5f5;
    padding: 10px 16px;
    gap: 0 32px;
    @include mixins.media('lg') {
      flex: 1 1 auto;
      padding: 22px 16px;
      gap: 0 20px;
    }
  }
  &_unit {
    flex: 1 1 100%;
    display: flex;
    align-items: center;
    @include mixins.media('lg') {
      justify-content: center;
    }
  }

  &_icon {
    width: 40px;
    height: 40px;
    background-color: #fff;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 8px;
    align-self: flex-start;
  }

  &_cnt {
    line-height: 1.3;
  }

  &_label {
    font-size: 1rem;

    @include mixins.media('lg') {
      font-size: 1.3rem;
      word-break: keep-all;
      white-space: nowrap;
    }
  }

  &_num {
    font-size: 1rem;

    @include mixins.media('lg') {
      font-size: 1.4rem;
      word-break: keep-all;
      white-space: nowrap;
    }

    > span {
      font-weight: bold;
      font-size: 1.5rem;
      letter-spacing: -0.03em;
      @include mixins.media('lg') {
        font-size: 2rem;
      }
    }
    .hospitalsDetailData_sub {
      font-size: 1rem;
      font-weight: normal;
      display: block;
      text-align: center;
      > span {
        transform: scale(0.5);
        transform-origin: left;
        display: inline-block;
        width: 6px;
        vertical-align: text-top;
      }
      @include mixins.media('lg') {
        font-size: 1.2rem;
        display: inline;
      }
    }
  }
}
</style>
